import Masonry from '../vendors/masonry.min';
import imagesLoaded from '../vendors/imagesloaded.min';
import inView       from './viewport';

export default function masonryGallery () {
    const container = document.querySelector('#gallery-grid-wrapper');
    const sizer = document.querySelector('.grid-sizer');
    let grid;

    const opts = {
        itemSelector: '.grid-item',
        columnWidth: sizer,
        horizontalOrder: false,
        percentPosition: true,
        gutter: '.gutter-sizer',
        initLayout: false,
        transitionDuration: '0.2s'
    };

    function toggleMasonry () {
        const ww = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        );

        if (ww >= 640) {
            grid.layout();
        } else {
            grid.destroy();
        }
    }

    if (typeof (container) !== 'undefined' && container !== null) {
        grid = new Masonry(container, opts);

        imagesLoaded('.grid-item').on('progress', () => {
            // toggleMasonry();
            grid.layout();
            inView();
        });

        // window.addEventListener('resize', toggleMasonry);
    }

    return {
      container: container,
      sizer: sizer,
      masonry: grid,
    };
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/masonry-gallery.js